import { gql } from "@apollo/client";

export const GET_HEADNOTES = gql`
  query lp_read(
    $options: read_options
    $region: Region!
    $type: DeLp_Type!
  ) {
    lp_read(options: $options, region: $region, type: $type) {
      message
      ok
      status
      total_count
      error {
        message
        path
      }
      data {
        head_notes {
          head_notes_id
          case_id
          heading
        }
      }
    }
  }
`;
